module.exports = __webpack_public_path__ + "img/canoe.40a91d31.png";